import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import moment from 'moment';

import Page from 'xpi-black-ui/Base/Page';
import { Row } from 'xpi-black-ui/Base/Grid';
import Button from 'xpi-black-ui/Base/Button';
import Select from  'xpi-black-ui/Base/Select';
import Wrapper from 'xpi-black-ui/Base/Wrapper';
import Loading from 'xpi-black-ui/Base/Loading';
import { H1, P } from 'xpi-black-ui/Base/Typography';
import { DateRangePicker, SingleDatePicker } from 'xpi-black-ui/Common/DatePicker';

import waConfig, { waDataReplace } from '../../utils/waConfig';

import Sidebar from '../../components/Common/Sidebar';
import PageView from '../../components/Common/PageView';
import BlackContainer from 'components/Common/BlackContainer';

import request from 'utils/request';
import { convertEnglishDate } from 'utils/helpers';
import { REPORT_COMMISSION_URL, REPORT_BARRIER_BEAT_URL, REPORT_POSITION_URL, REPORT_OPERATIONS_URL, REPORT_FIXING_ASSET_URL, REPORT_FIXING_NO_ASSET_URL } from 'utils/api';

import { FieldSet, DatePicker, Form } from './styles';

moment.locale('pt-br');

function ReportsPage() {
  const [singleDate, setSingleDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [startDate, setStartDate] = useState(undefined);
  const [loadingPage, setLoadingPage] = useState(undefined);
  const [reportSelected, setReportSelected] = useState({});

  const downloadReport = (response, reportName) => {
    const file = new Blob([response], {
      type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    let a = document.createElement("a");
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(file);
    a.href = url;
    a.download = `Relatório de ${reportName}`;
    a.click();
  };

  const onGetReport = () => {
    setLoadingPage(true);
    const { label, url, enableRangePicker } = reportSelected;

    let startDateRef, endDateRef, singleDateRef, param, date;

    if (enableRangePicker) {
      startDateRef = convertEnglishDate(startDate);
      endDateRef = convertEnglishDate(endDate);
      param = `dataReferenciaInicial=${startDateRef}&dataReferenciaFinal=${endDateRef}`;
    } else {
      singleDateRef = convertEnglishDate(singleDate);
      param = `dataReferencia=${singleDateRef}`;
    }

    request(`${url}?${param}`, { responseType: 'arraybuffer' })
      .then(response => {
        const { error } = response;
        if (error) {
          toastr.error('Erro ao carregar o relatório', 'Tente novamente');
        } else {
          if (response.byteLength > 0) {
            downloadReport(response, label);
          } else {
            toastr.info('Nenhum registro encontrado', 'Tente outra data');
          }
        }
        setLoadingPage(false);
      });
  };

  const reportsList = [
    { value: 'barrier', label: 'Batimento de Barreira', url: REPORT_BARRIER_BEAT_URL, enableRangePicker: true, enableFullCalendar: false, description:'Este relatório contém as informações das operações executadas via mesa e cotizador e que tiveram barreiras batidas no período selecionado. <br /> <br /> O período máximo de extração de dados é de 6 meses. Para períodos maiores, por favor, realize mais de uma busca.'},
    { value: 'commission', label: 'Comissão', url: REPORT_COMMISSION_URL, enableRangePicker: true, enableFullCalendar: false, description:'Este relatório contém as informações de comissionamento das operações realizadas via mesa e cotizador. <br /> <br /> O período máximo de extração de dados é de 6 meses. Para períodos maiores, por favor, realize mais de uma busca. '},
    { value: 'fixing_asset', label: 'Fixing', url: REPORT_FIXING_ASSET_URL, enableRangePicker: true, enableFullCalendar: true, description:'Este relatório contém as informações das operações executadas via cotizador com e sem compra de ativo e com fixing no período selecionado. <br /> <br />O período máximo de extração de dados é de 6 meses. Para períodos maiores, por favor, realize mais de uma busca.'},
    { value: 'operations', label: 'Operações Executadas', url: REPORT_OPERATIONS_URL, enableRangePicker: true, enableFullCalendar: false, description:'Este relatório contém as informações das operações executadas via mesa e cotizador no período selecionado. <br /> <br />O período máximo de extração de dados é de 6 meses. Para períodos maiores, por favor, realize mais de uma busca.'},
    { value: 'position', label: 'Posição', url: REPORT_POSITION_URL, enableRangePicker: false, enableFullCalendar: false, description:'Este relatório contém as informações de posição das operações em aberto executadas via mesa e cotizador.'},
  ];

  const isValidRangeBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate).getMonth() + 1;
    const end = new Date(endDate).getMonth() + 1;
    const differenceOfMonths = end - start;
    const monthLimit = 6;

    return differenceOfMonths <= monthLimit;
  };

  const checkRangeBetweenDates = (startDate, endDate) => {
    if (!isValidRangeBetweenDates(startDate, endDate)) {
      toastr.error('Período inválido', 'Selecione um período de até 6 meses');
    }
  };

  const onRangeDatesChange = dates => {
    const { startDate, endDate } = dates;
    if (startDate && endDate) {
      setEndDate(endDate);
      setStartDate(startDate);

      checkRangeBetweenDates(startDate, endDate);
    }
  };

  const isEnableGetReport = () => {
    let hasValidaDate = false;
    if (reportSelected?.enableRangePicker) {
      hasValidaDate = startDate && endDate && isValidRangeBetweenDates(startDate, endDate);
    } else {
      hasValidaDate = singleDate;
    }

    return !(hasValidaDate && Object.keys(reportSelected).length > 0);
  }

  const d1 = new Date((new Date()).valueOf() + 1000*3600*1);

  return (
    <BlackContainer>
      <Page>
        <PageView page={waConfig.pageview.reports} />
        {loadingPage && <Loading text="Carregando..." fixed />}
        <Row align="normal" style={{ width: '100%' }}>
          <Sidebar>
            <P bigger>Módulo do Black para ajduar você assessor no acompanhamento das operações dos seus clientes.</P>
          </Sidebar>
          <Wrapper spaceTop innerWrapper>
            <H1>Relatórios Gerenciais</H1>

            <Form>
              <FieldSet>
                <Select
                  options={reportsList}
                  onChange={value => setReportSelected(value)}
                  placeholder="Selecione o relatório"
                  noOptionsMessage={() => ('Relatório não disponível')}
                />
              </FieldSet>

              <FieldSet>
                <DatePicker>
                  {reportSelected?.enableRangePicker
                    ?
                      <DateRangePicker
                        onDatesChange={onRangeDatesChange}
                        isDayBlocked={date => reportSelected?.enableFullCalendar ? false : date > new Date()}
                      />
                    :
                      <SingleDatePicker
                        date={singleDate}
                        onChange={value => setSingleDate(value)}
                        isDayBlocked={date => date.isAfter(moment(d1))}
                      />
                  }
                </DatePicker>
              </FieldSet>
              <FieldSet>
                <Button
                  disabled={isEnableGetReport()}
                  onClick={() => onGetReport()}
                  data-wa={waDataReplace(waConfig.event.reports.download, reportSelected.label)}
                >
                  Baixar
                </Button>
              </FieldSet>
            </Form>
            {reportSelected?.description && (
              <>
                <P bold style={{ marginBottom: '8px'}}>Entenda melhor o seu relatório:</P>
                <div id='push-content' dangerouslySetInnerHTML={{ __html: reportSelected?.description }} />
              </>
            )}
          </Wrapper>
        </Row>
      </Page>
    </BlackContainer>
  );
}

export default ReportsPage;
